/* PDP theme — nav, accordions, quantity steppers, retail/installer price switch */
(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  var CFG = window.PDP || {};
  var VAT = 0.15;

  /* ---------- storage that never throws ---------- */
  var mem = {};
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return mem[k] || null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) { mem[k] = v; } }
  };

  /* ---------- money ---------- */
  function money(cents) {
    return 'R' + Math.round(cents / 100).toLocaleString('en-ZA');
  }

  /* ---------- trade price book ---------- */
  var book = null;          // { SKU: tradePriceInCents }
  var mode = store.get('pdp_mode') === 'trade' ? 'trade' : 'retail';

  function tradeCents(el) {
    var retail = parseInt(el.dataset.retail || '0', 10);
    if (!retail) return 0;
    var sku = el.dataset.sku;
    if (book && sku && book[sku] != null) return book[sku];
    // fallback: strip VAT off the retail price, then apply the configured discount
    var ex = retail / (1 + VAT);
    return Math.round(ex * (1 - (CFG.fallback || 24) / 100));
  }

  function paint() {
    var trade = mode === 'trade' && !CFG.isB2B;
    document.body.classList.toggle('trade-mode', trade);
    $$('.pmode button[data-mode]').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.mode === mode);
    });

    $$('[data-price]').forEach(function (el) {
      var val = $('.price__value', el);
      var lab = $('.price__label', el);
      var was = $('.price__was', el);
      var sav = $('.price__save', el);
      if (!val) return;

      if (!el.dataset.retailHtml) {
        el.dataset.retailHtml = val.textContent;
        el.dataset.retailLabel = lab ? lab.innerHTML : '';
        el.dataset.retailWas = was ? was.innerHTML : '';
        el.dataset.retailSave = sav ? sav.innerHTML : '';
      }

      if (trade) {
        var t = tradeCents(el);
        var r = parseInt(el.dataset.retail || '0', 10);
        val.textContent = money(t);
        if (lab) lab.innerHTML = 'excl. VAT &middot; trade';
        if (was) was.innerHTML = '<span class="was">' + money(r) + '</span>';
        if (sav) sav.innerHTML = '<span class="save">Save ' + money(r - t) + '</span>';
      } else {
        val.textContent = el.dataset.retailHtml;
        if (lab) lab.innerHTML = el.dataset.retailLabel;
        if (was) was.innerHTML = el.dataset.retailWas;
        if (sav) sav.innerHTML = el.dataset.retailSave;
      }
    });
  }

  function loadBook(then) {
    if (book || !CFG.tradeUrl) { then(); return; }
    fetch(CFG.tradeUrl)
      .then(function (r) { return r.json(); })
      .then(function (j) { book = j; then(); })
      .catch(function () { book = {}; then(); });
  }

  function setMode(m) {
    if (m === 'trade' && mode !== 'trade') { openModal(); return; }
    mode = m; store.set('pdp_mode', m);
    loadBook(paint);
    toast(m === 'trade' ? 'Installer pricing shown (indicative)' : 'Retail pricing shown');
  }

  // Where a pricing pill sends the visitor. Blank setting = stay put.
  function goToShop() {
    if (!CFG.shopUrl) { return; }
    var target = CFG.shopUrl.split('?')[0].split('#')[0];
    if (location.pathname.replace(/\/$/, '') === target.replace(/\/$/, '')) { return; }
    location.href = CFG.shopUrl;
  }

  /* ---------- trade code gate ---------- */
  function openModal() {
    var m = $('#tradeModal'); if (!m) return;
    m.classList.add('is-open');
    var i = $('#tradeCode'); if (i) { i.value = ''; setTimeout(function () { i.focus(); }, 120); }
  }
  function closeModal() {
    var m = $('#tradeModal'); if (m) m.classList.remove('is-open');
    var e = $('#tradeErr'); if (e) e.classList.remove('show');
  }
  function submitCode() {
    var v = ($('#tradeCode') || {}).value || '';
    if (v.trim().toUpperCase() === String(CFG.tradeCode || '').toUpperCase()) {
      closeModal();
      mode = 'trade'; store.set('pdp_mode', 'trade');
      loadBook(paint);
      toast('Installer pricing unlocked');
      goToShop();
    } else {
      var e = $('#tradeErr'); if (e) e.classList.add('show');
    }
  }

  /* ---------- toast ---------- */
  var tTimer;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(tTimer);
    tTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.reveal');
    if (!els.length) return;
    document.body.classList.add('js-on');

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px' });
    els.forEach(function (el) { io.observe(el); });

    // anything already on screen shows immediately, no wait for a scroll
    requestAnimationFrame(function () {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('in');
      });
    });
  }

  /* ---------- add to cart without leaving the page ---------- */
  // Markets and translated storefronts live under a prefix like /en-za.
  // Hard-coding "/cart/add.js" 404s on those, so read the real root.
  function shopRoot() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return r.replace(/\/$/, '');
  }

  function initCartAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form[data-cart-add]')) { return; }

      var idEl = form.querySelector('[name="id"]');
      var qtyEl = form.querySelector('[name="quantity"]');
      var id = idEl ? String(idEl.value || '').trim() : '';

      // Anything unexpected -> let the browser POST the form normally, so the
      // button still works even when the fancy path is broken.
      if (!id || !window.fetch) {
        if (!id) { console.error('[PDP] add to cart: no variant id on this card'); }
        return;
      }

      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      var bailed = false;

      function restore() {
        if (btn && !bailed) { btn.disabled = false; btn.innerHTML = label; }
      }
      function fallback(why) {
        console.error('[PDP] add to cart failed, posting the form instead:', why);
        bailed = true;
        form.submit();          // native submit — does not re-trigger this handler
      }

      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch(shopRoot() + '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: parseInt(qtyEl && qtyEl.value, 10) || 1 })
      })
      .then(function (r) {
        return r.text().then(function (t) {
          var d = {};
          try { d = JSON.parse(t); } catch (x) {}
          return { ok: r.ok, status: r.status, data: d, raw: t };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          // 422 means Shopify itself refused — out of stock, or a bad variant.
          // Posting the form again would fail the same way, so show the reason.
          if (res.status === 422) {
            console.error('[PDP] Shopify refused the add:', res.raw);
            toast(res.data.description || res.data.message || 'That item could not be added');
            restore();
            return null;
          }
          return fallback('HTTP ' + res.status);
        }
        if (btn) { btn.textContent = 'Added ✓'; }
        toast('Added to your cart');
        return fetch(shopRoot() + '/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            $$('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
          });
      })
      .catch(function (err) { fallback(err && err.message); })
      .then(function () { setTimeout(restore, 1600); });
    });
  }

  /* ---------- hero sizing tool ---------- */
  // All numbers come from the section's settings, injected as JSON by
  // hero-sizer.liquid. Nothing is hard-coded here — edit it in Customize.
  function initSizer() {
    var form = $('#sizer');
    if (!form || form.dataset.sizerReady) { return; }

    var tag = $('#sizerData');
    if (!tag) { return; }
    var cfg;
    try { cfg = JSON.parse(tag.textContent); } catch (e) { return; }
    if (!cfg || !cfg.bands) { return; }
    form.dataset.sizerReady = '1';

    function read(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : null;
    }
    function num(v) { var n = parseFloat(v); return isNaN(n) ? 0 : n; }
    function round1(n) { return Math.round(n * 10) / 10; }
    function rands(n) {
      return (cfg.pricePrefix || 'R') +
             String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    }

    function paintSizer() {
      var band = cfg.bands[read('bill')];
      if (!band) { return; }

      var goal = read('goal') || 'both';
      var adj = cfg.adjust || {};
      var inv = num(band.inv), bat = num(band.bat), arr = num(band.arr);

      if (goal === 'backup') {
        // riding out outages: keep the battery, cut the array back
        arr = round1(arr * (adj.backupArray || 0.5));
      } else if (goal === 'offgrid') {
        // no grid to fall back on: more of everything
        inv = inv + (adj.offgridInvAdd || 0);
        bat = round1(bat * (adj.offgridBat || 1));
        arr = round1(arr * (adj.offgridArray || 1));
      }

      var i = $('#szInv'), b = $('#szBat'), a = $('#szArr');
      if (i) i.textContent = round1(inv) + 'kW';
      if (b) b.textContent = round1(bat) + 'kWh';
      if (a) a.textContent = round1(arr) + 'kWp';

      // Price is whatever the merchant typed for this exact combination —
      // never calculated, so the site can't invent a number.
      var cell = $('#szPriceCell'), out = $('#szPrice');
      if (cell && out) {
        var p = band.price ? num(band.price[goal]) : 0;
        if (cfg.showPrice && p > 0) {
          out.textContent = rands(p);
          cell.style.display = '';
        } else {
          cell.style.display = 'none';
        }
      }

      var box = $('#sizerOut');
      if (box && box.hasAttribute('hidden')) { box.removeAttribute('hidden'); }
    }

    form.addEventListener('change', paintSizer);
    paintSizer();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initSizer();
    initCartAdd();

    // the theme editor swaps section HTML in and out — re-scan when it does
    document.addEventListener('shopify:section:load', function () {
      initReveal();
      initSizer();
    });

    /* price switch */
    if (CFG.hasToggle && !CFG.isB2B) {
      $$('.pmode button[data-mode]').forEach(function (b) {
        b.title = CFG.shopUrl ? 'Opens the store' : '';
        b.addEventListener('click', function () {
          // One click always ends at the store. If the mode also needs to
          // change, it changes on the way. Destination is set in
          // Theme settings > Trade > "Second click on the price pill opens".
          var m = b.dataset.mode;
          if (m === mode) { goToShop(); return; }
          setMode(m);
          if (mode === m) { goToShop(); }
          // switching to trade opens the code gate instead; submitCode()
          // navigates once the code is accepted
        });
      });
      var exit = $('#exitTrade');
      if (exit) exit.addEventListener('click', function () { setMode('retail'); });

      var mm = $('#tradeModal');
      if (mm) {
        mm.addEventListener('click', function (e) { if (e.target === mm) closeModal(); });
        var go = $('#tradeGo'); if (go) go.addEventListener('click', submitCode);
        var cx = $('#tradeCancel'); if (cx) cx.addEventListener('click', closeModal);
        var inp = $('#tradeCode');
        if (inp) inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') submitCode(); });
      }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

      if (mode === 'trade') loadBook(paint); else paint();
    }

    var burger = $('#burger'), links = $('#navLinks');
    if (burger && links) {
      burger.addEventListener('click', function () {
        burger.classList.toggle('is-open');
        links.classList.toggle('is-open');
      });
    }

    $$('.acc__q').forEach(function (q) {
      q.addEventListener('click', function () {
        var acc = q.parentElement, a = $('.acc__a', acc);
        var open = acc.classList.toggle('is-open');
        a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
      });
    });

    $$('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = $('input[name="quantity"]', b.parentElement);
        if (!input) return;
        var n = parseInt(input.value || '1', 10) + parseInt(b.dataset.qty, 10);
        input.value = Math.max(1, n);
      });
    });
  });
})();
